/*
 * Copyright (c) 2024. Tooling Team
 */
import { Footer } from "@uhg-abyss/web/ui/Footer";
import { Brandmark } from "@uhg-abyss/web/ui/Brandmark";

export function MintFooter() {
  //todo: replace divs with V2Footer subcomponents when available in v2 upgrade
  const subFooterLinks = [
    { label: "Home", href: "/" },
    { label: "Help", href: "https://www.optum.com/contact.html" },
  ];

  return (
    <Footer variant="alt">
      <Brandmark
        affiliate="optum"
        size="$sm"
        variant="lockup"
        color="orange"
        brand="optum"
      />
      <Footer.SubFooter
        copyright={"Optum, Inc. All rights reserved."}
        links={subFooterLinks}
      />
    </Footer>
  );
}
